import { motion } from "framer-motion";
import React, { useState } from "react";
import "react-phone-input-2/lib/style.css";
import Edit from "./edit";
import Passwords from "./passwords";
import { appear } from "./config/appear";
import { slide } from "./config/slide";
import { ProfileProps } from "./domain/types";
import { FiX } from "react-icons/fi";
import { useAuth } from "hooks/useAuth";

const Profile: React.FC<ProfileProps> = ({ closeMenu, onLicenseClick, setShowLicenseDetails, showProfileMenu, profileConfig, hooks, children }) => {
  const { updateProfile, mapPicture, uploadPicture, passwordConfig } = profileConfig;
  const { userInfo } = useAuth();
  const [screen, setScreen] = useState("default");
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState<any>(null);

  const refreshUser = async () => {
    // const response: any = await getUserInfo();
    // if (response?.status === 200) {
    //   setUser(response.data);
    // }
  };

  const updateHandler = async (data: any, fileId: string) => {
    setLoading(true);

    if (fileId)
      await mapPicture({ fileId });

    const response2 = await updateProfile(data);
    if (response2.status === 200) {
      refreshUser();
    } else {
      setError("There was an issue updating profile please try later");
    }
    setLoading(false);
  };

  return (
    <motion.div
      className=" z-50 absolute overflow-hidden left-0 top-0 w-screen h-screen bg-dark/65 flex items-center justify-center align-middle"
      initial="exit"
      animate={showProfileMenu ? "enter" : "exit"}
      variants={appear}
      onClick={closeMenu}
    >
      <motion.div
        initial="exit"
        animate={showProfileMenu ? "enter" : "exit"}
        variants={slide}
        className="w-[65%] h-[82%] mt-20 z-50 flex items-center justify-center mx-auto my-auto relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="bg-blue cursor-pointer rounded-md p-1 h-max absolute top-2 right-2 z-50"
          onClick={closeMenu}
        >
          <FiX size={20} />
        </button>
        <div className="relative p-4 bg-midnight w-full h-full rounded-lg overflow-hidden">
          {(screen === "default" || screen === "edit") && userInfo && (
            <>
              {userInfo && (
                <div className="h-full w-full flex flex-col">
                  {/* info */}
                  <div className="rounded-md m-3 h-full max-h-full">
                    <div className="bg-dark rounded-md flex justify-between items-center h-full">
                      <div className="w-full h-full">
                        {/* Avatar */}
                        <div className="flex justify-center items-center relative w-full h-full">
                          <Edit
                            setScreen={setScreen}
                            user={userInfo}
                            update={updateHandler}
                            uploadPicture={uploadPicture}
                            loading={loading}
                            error={error}
                          />
                        </div>
                      </div>
                      <div>
                        {children}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          {screen === "passwords" && <Passwords setScreen={setScreen} passwordConfig={passwordConfig} />}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Profile;